module.exports = __webpack_public_path__ + "img/PTT.d98f2f6b.png";